import apiClient from './apiClient';

export const userService = {
  async getPreferences() {
    try {
      const response = await apiClient.get('/users/preferences');
      if (response.data.result === 'SUCCESS') {
        return response.data.data;
      } else {
        throw new Error(response.data.message || 'Failed to fetch preferences');
      }
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw new Error('Failed to fetch preferences. Please try again.');
    }
  },

  async updatePreferences(timezone, localePreference) {
    try {
      const response = await apiClient.put('/users/preferences', {
        timezone,
        localePreference,
      });
      if (response.data.result === 'SUCCESS') {
        return response.data.data;
      } else {
        throw new Error(response.data.message || 'Failed to update preferences');
      }
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw new Error('Failed to update preferences. Please try again.');
    }
  },
};
